import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../shared/spinner.component';

import { waitForSpinnerToShowUp } from '../../shared/cursorHelpers';

import DropdownMenu from '../../shared/dropdownMenu';

class HamburgerDropdown extends PureComponent {
  static propTypes = {
    cannotDownloadDiagnostics: PropTypes.bool.isRequired,
    downloadDiagnostics: PropTypes.func.isRequired,
  };

  state = {
    isGeneratingXlsxFile: false,
  };

  hideDropDown = () => {
    this.dropdown.hideDropDown();
  };

  downloadDiagnostics = () => {
    this.setState({ isGeneratingXlsxFile: true }, () => {
      waitForSpinnerToShowUp({
        action: this.props.downloadDiagnostics,
        callback: () => {
          this.hideDropDown();
          this.setState({ isGeneratingXlsxFile: false });
        },
      });
    });
  };

  render() {
    const { isGeneratingXlsxFile } = this.state;

    return (
      <DropdownMenu ref={dropdown => this.dropdown = dropdown} contentClassName="hamburger-menu">
        {this.props.cannotDownloadDiagnostics ? null : (
          <button
            className="hamburger-action"
            tabIndex="0"
            onClick={this.downloadDiagnostics}
          >
            {isGeneratingXlsxFile
              ? (
                <span>
                  <Spinner small/> Export to Excel
                </span>
              )
              : 'Export to Excel'
            }
          </button>
        )}
      </DropdownMenu>
    );
  }
}

export default HamburgerDropdown;
